module.exports = "<div class=\"modal_wrapper\">\n    <div class=\"modal_overlay external\" ng-click=\"modal.close()\"></div>\n    <div class=\"modal external\">\n        <div class=\"modal__header\">\n            <h2>Help</h2>\n            <button class=\"close\" ng-click=\"modal.close()\"></button>\n        </div>\n        <div class=\"modal_body\">\n          <iframe width=\"100%\" height=\"100%\" src=\"content/help/help.html\" frameborder=\"0\" allowfullscreen></iframe>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/help/view.html
// module id = 398
// module chunks = 0